import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { green, grey } from '@material-ui/core/colors';
import CloseIcon from '@material-ui/icons/Close';
import useIntl from '../hooks/useIntl';

const useStyles = makeStyles((theme) => ({
  typography: {
    float: 'right',
    marginRight: '5px',
    fontSize: 'small'
  },
  listItemText: {
    fontSize: '1em', //Insert your required size
  },
  closeIcon: {
    display: 'none',
    // display: 'flex',
    // justifyContent: 'flex-end',
    // paddingRight: '0.5em',
    // cursor: 'pointer'
  }
}));

export default function GreenLightsPopover({ text, data }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { translate } = useIntl();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <React.Fragment>
      <Typography aria-describedby={id} onClick={handleClick} style={{fontSize: '0.875rem'}}>
        <FiberManualRecordIcon style={{ color: data.total ? green[400] : grey[300] }} />
        {text}
      </Typography>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <React.Fragment>
          <List style={{paddingBottom: '0px'}}>
            <div className={classes.closeIcon} onClick={handleClose}>
              <CloseIcon />
            </div>
            {
              Object.entries(data.events).map(([key, val]) => {
              return (
                <ListItem
                  key={key}
                  style={{ paddingTop: '2px', paddingBottom: '2px' }}
                >
                  <ListItemIcon style={{ minWidth: '40px' }}>
                    <FiberManualRecordIcon
                      style={{ color: val ? green[400] : grey[300] }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={translate(`greenlights.event.${key}`)}
                    classes={{ primary: classes.listItemText }}
                  />
                </ListItem>
              );
            })
          }
          </List>
          <Typography className={classes.typography}>
            Source: {data.source}
          </Typography>
        </React.Fragment>
      </Popover>
    </React.Fragment>
  );
}
